/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { getCurrentQtr } from '../../../../SharedModules/utilities/utilities';
import * as ActionTypes from './actionTypes';

const initialState = {
  isLoading: false,
  errors: [],
  selectedOption: 'Request Display Of Quarterly Report',
  screenGridData: [],
  headerGridData: [],
  leftGridData: [],
  rightGridData: [],
  leftGridDataForAll: {},
  rightGridDataForAll: {},
  selectedRequest: {},
  lasUpdatedUserIdAndCount: 'default',
  scheduleMessage: null,
  qtr: getCurrentQtr().join('Q'),
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_SELECTED_INPUT:
      return { ...state, ...action.payload };
    case ActionTypes.REFRESH_QUAERTERLY_CLAIMS_RECONCILLIATION:
      return {
        ...initialState,
        selectedRequest: state.selectedRequest,
        leftGridData: state.leftGridData,
        rightGridData: state.rightGridData,
        headerGridData: state.headerGridData,
      };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SET_REQUEST_SCREEN_GRID:
      return { ...state, screenGridData: action.payload };
    case ActionTypes.SET_HEADER_GRID:
      return { ...state, headerGridData: action.payload };
    case ActionTypes.SET_LEFT_GRID_DATA:
      return { ...state, leftGridData: action.payload };
    case ActionTypes.SET_RIGHT_GRID_DATA:
      return { ...state, rightGridData: action.payload };
    case ActionTypes.SET_LEFT_GRID_DATA_FOR_ALL:
      const data = {
        [action.rebateProgram]: action.payload,
        ...state.leftGridDataForAll,
      };
      return {
        ...state,
        leftGridDataForAll: data,
      };
    case ActionTypes.SET_RIGHT_GRID_DATA_FOR_ALL:
      const dataRight = {
        [action.rebateProgram]: action.payload,
        ...state.rightGridDataForAll,
      };
      return {
        ...state,
        rightGridDataForAll: dataRight,
      };
    case ActionTypes.SET_SELECTED_REQUEST:
      return { ...state, selectedRequest: action.payload };
    case ActionTypes.SET_LAST_UPDATED_USERID_AND_COUNT:
      return { ...state, lasUpdatedUserIdAndCount: action.payload };
    case ActionTypes.SET_SCHEDULE_MESSAGE:
      return { ...state, scheduleMessage: action.payload };
    default:
      return state;
  }
};

export default reducer;
